/**
 * CLASSE DE CONTROLE PARA PROMISSE
 *
 * 1- MODIVO:
 *      - AO SE CRIAR UMA PROMISE, A MESMA NÃO POSSUI CONTROLE PARA SABER SE AINDA ESTÁ EM EXECUÇÃO PENDENTE OU TERMINOU,
 *      - AO SER UTILIZADO ESTA CLASSE DE CONTROLE A PROMISSE PASSA A GANHAR 3 PROPRIEDADES (myPromise.status) QUE PODEM
 *        SER UTILIZADA COMO CONTROLE DE CAMPOS NA TELA, ATIVAR E DESATIVAR CAMPOS EM GERAL...
 */
export default class PromiseCall {
  constructor(fnPromise, fnResolve, fnReject) {
    this.init();
  }

  init() {
    this.status = {
      pending: false,
      resolved: false,
      rejected: false,
    };
  }

  setResolved() {
    this.init();
    this.status.resolved = true;
  }

  setRejected() {
    this.init();
    this.status.rejected = true;
  }

  setPending() {
    this.init();
    this.status.pending = true;
  }


  isPending() {
    return this.status.pending;
  }

  isRejected() {
    return this.status.rejected;
  }

  isResolved() {
    return this.status.resolved;
  }


  run(fnPromise, fnResolve, fnReject) {
    if (this.isPending()) return;
    this.setPending();
    fnPromise.then(res => {
      this.setResolved();
      return fnResolve(res);
    });
    fnPromise.catch(err => {
      this.setRejected();
      return fnReject(err);
    });
  }
}
